import React, { useMemo } from 'react';
import { GUESTS_TYPE } from '../constants';
import { intl } from '../lang/INTL';
import useWidgetStore from '../store/useWidgetStore';

export const useDisplayRooms = (callback) => {
  const rooms = useWidgetStore((state) => state.rooms);
  const multiRoomEnabled = useWidgetStore((state) => state.hotelData?.enable_multiple_rooms);

  const guestCount = useMemo(() => {
    return rooms
      ?.flatMap((item) => item.data || [])
      ?.filter((entry) => typeof entry.count === 'number')
      ?.reduce((a, b) => a + b.count, 0);;
  }, [JSON.stringify(rooms)]);

  const adultsOnly = useMemo(() => {
    return rooms
      ?.flatMap((item) => item.data || [])
      ?.filter((entry) => typeof entry.count === 'number' && entry.count > 0)
      ?.every((entry) => entry.type === GUESTS_TYPE.ADULT)
  }, [JSON.stringify(rooms)]);

  const triggerText = useMemo(() => {
    if (typeof multiRoomEnabled === 'undefined') {
      return null;
    }

    const guestsText = adultsOnly ? intl.formatMessage(
      {
        id: 'rooms.adultsCount',
        defaultMessage: '{count} {count, plural, =1 {adult} other {adults}}',
      },
      {
        count: guestCount,
      },
    ) : intl.formatMessage(
      {
        id: 'rooms.guestsCount',
        defaultMessage: '{count} {count, plural, =1 {guest} other {guests}}',
      },
      {
        count: guestCount,
      },
    );

    if (!multiRoomEnabled) {
      return guestsText;
    }

    const roomsText = intl.formatMessage(
      {
        id: 'rooms.roomsCount',
        defaultMessage: '{count} {count, plural, =1 {room} other {rooms}}',
      },
      {
        count: rooms.length,
      },
    );

    return `${guestsText}, ${roomsText}`;
  }, [rooms.length, guestCount, multiRoomEnabled]);

  return {
    guestCount,
    roomsCount: rooms?.length,
    triggerText,
  };
};
